(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('SSPeriodo', SSPeriodo);

    SSPeriodo.$inject = ['$resource', 'DateUtils'];

    function SSPeriodo ($resource, DateUtils) {
        var resourceUrl =  'api/s-s-periodos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'all': { 
            	method: 'GET',
            	url:'api/s-s-periodos-all',
            	isArray: true
           	},
            'getPeriodoVigente': {
                method: 'GET',
                url:'api/s-s-periodo-vigente',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniPeriodo = DateUtils.convertDateTimeFromServer(data.iniPeriodo);
                        data.finPeriodo = DateUtils.convertDateTimeFromServer(data.finPeriodo);
                        data.iniConvocatoria = DateUtils.convertDateTimeFromServer(data.iniConvocatoria);
                        data.finConvocatoria = DateUtils.convertDateTimeFromServer(data.finConvocatoria);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    } else {
                    	data = null;
                    }
                    return data;
                }
            },
            'getPeriodoConvocatoriaVigente': {
                method: 'GET',
                url:'api/s-s-periodo-convocatoria-vigente',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniPeriodo = DateUtils.convertDateTimeFromServer(data.iniPeriodo);
                        data.finPeriodo = DateUtils.convertDateTimeFromServer(data.finPeriodo);
                        data.iniConvocatoria = DateUtils.convertDateTimeFromServer(data.iniConvocatoria);
                        data.finConvocatoria = DateUtils.convertDateTimeFromServer(data.finConvocatoria);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    } else {
                    	data = null;
                    }
                    return data;
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.iniPeriodo = DateUtils.convertDateTimeFromServer(data.iniPeriodo);
                        data.finPeriodo = DateUtils.convertDateTimeFromServer(data.finPeriodo);
                        data.iniConvocatoria = DateUtils.convertDateTimeFromServer(data.iniConvocatoria);
                        data.finConvocatoria = DateUtils.convertDateTimeFromServer(data.finConvocatoria);
                        data.altaReg = DateUtils.convertDateTimeFromServer(data.altaReg);
                        data.bajaReg = DateUtils.convertDateTimeFromServer(data.bajaReg);
                        data.ultActReg = DateUtils.convertDateTimeFromServer(data.ultActReg);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
